// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Box, Button } from 'grommet';
import { HTTP_400_BAD_REQUEST, ApiClient } from 'speed-js-core';
import { connectAPI, withRouter } from 'speed-js-react';
import { GrommetForm } from 'speed-js-react-web';
import { setPermissions, setUser } from 'speed-js-react/src/redux/auth/actions';

type Props = {
    // eslint-disable-next-line react/no-unused-prop-types
    authResource: string,
    // eslint-disable-next-line react/no-unused-prop-types
    redirectTo: string,
}


type CombinedProps = Props & {
    getSchema: () => Promise<Object>,
    schema: Object,
    login: (data: Object, formik: Object) => Promise<Object>,
    history: { push: (location: string) => void },
};


const mapDispatchToProps = (dispatch: function) => ({
    dispatchSetUser: (user: Object) => dispatch(setUser(user)),
    dispatchSetPermissions: (permissions: Object) => dispatch(setPermissions({ permissions })),
});

const locales = {
    login: (
        <FormattedMessage
            id="loginform.login"
            defaultMessage="Login"
            description="Login button"
        />
    ),
};

@withRouter
@connect(null, mapDispatchToProps)
@connectAPI((apiClient: ApiClient, props: CombinedProps) => ({
    getSchema: {
        send: () => apiClient.resources[props.authResource].loginSchema(),
        success: (schema: Object) => ({ schema }),
    },
    login: {
        send: (data: Object) => apiClient.authorize(data),
        success: (response: { user: Object }, data: Object, formik: Object) => {
            const { data: { user } } = response;

            const {
                history, redirectTo, dispatchSetUser, dispatchSetPermissions,
            } = props;
            history.push(redirectTo);
            dispatchSetUser(user);
            dispatchSetPermissions(user.permissions);
            formik.setSubmitting(false);
        },
        error: (response: Object, data: Object, formik: Object) => {
            formik.setSubmitting(false);
            if (response.status === HTTP_400_BAD_REQUEST) {
                formik.setErrors(response.data);
            }
        },
    },
}))
class LoginForm extends React.Component<CombinedProps> {
    static defaultProps: Object;

    componentDidMount() {
        const { getSchema } = this.props;
        getSchema();
    }

    handleSubmit = (values: Object, formik: Object) => {
        const { login } = this.props;

        login(values, formik);
    };

    renderActions = ({ isSubmitting }: { isSubmitting: boolean }) => (
        <Box dirextion="row" margin={{ vertical: 'small' }}>
            <Button label={locales.login} type="submit" alignSelf="end" disabled={isSubmitting} />
        </Box>
    );

    render() {
        const { schema } = this.props;

        if (!schema) {
            // TODO: loading state
            return null;
        }

        return (
            <GrommetForm
                schema={schema}
                onSubmit={this.handleSubmit}
                actions={this.renderActions}
            />
        );
    }
}

LoginForm.defaultProps = {
    authResource: 'auth',
    redirectTo: '/',
};

export default LoginForm;
